import { useTranslation } from "react-i18next";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGUAGES = {
  en: { label: "English", icon: "/icons/uk-icon.svg", alt: "UK flag" },
  fr: { label: "Français", icon: "/icons/fr-icon.svg", alt: "French flag" },
} as const;

type SupportedLanguage = keyof typeof LANGUAGES;

type LanguageSelectorType = {
  callback?: (lng: string) => void;
};

export const LanguageSelector = ({ callback }: LanguageSelectorType) => {
  const { i18n } = useTranslation();

  const lang = (i18n.language in LANGUAGES ? i18n.language : "en") as SupportedLanguage;
  const { label, icon, alt } = LANGUAGES[lang];

  const changeLanguage = (lng: SupportedLanguage) => {
    i18n.changeLanguage(lng);
    callback?.(lng);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="w-40 border border-input rounded-md text-sm flex justify-between items-center gap-2 px-2.5 py-2">
        <img key={lang} src={icon} className="w-5 h-5" alt={alt} />
        <div className="flex-1 text-left mr-2.5 hidden md:block">
          {label}
        </div>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6L8 10L12 6" stroke="#808080" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {Object.entries(LANGUAGES).map(([lng, { label }]) => (
          <DropdownMenuItem key={lng} onClick={() => changeLanguage(lng as SupportedLanguage)}>
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};